import { supabase } from "@/lib/supabase";

export interface DocumentHistory {
  id: string;
  user_id: string;
  title: string;
  date: string;
  type: string;
  status: string;
  content: string;
  url?: string;
}

export async function getUserDocuments(
  userId: string
): Promise<DocumentHistory[]> {
  const { data, error } = await supabase
    .from("documents_history")
    .select("*")
    .eq("user_id", userId)
    .order("date", { ascending: false })
    .limit(5);
  if (error) throw error;
  return data || [];
}

export async function addDocument(
  doc: Omit<DocumentHistory, "id">
): Promise<void> {
  // Insert new document
  const { error } = await supabase.from("documents_history").insert([doc]);
  if (error) throw error;
  // Keep only 5 most recent
  const { data: docs } = await supabase
    .from("documents_history")
    .select("id")
    .eq("user_id", doc.user_id)
    .order("date", { ascending: false });
  if (docs && docs.length > 5) {
    const idsToDelete = (docs as Pick<DocumentHistory, "id">[])
      .slice(5)
      .map((d) => d.id);
    await supabase.from("documents_history").delete().in("id", idsToDelete);
  }
}

export async function updateDocument(
  id: string,
  data: Partial<DocumentHistory>
): Promise<void> {
  const { error } = await supabase
    .from("documents_history")
    .update(data)
    .eq("id", id);
  if (error) throw error;
}

export async function deleteDocument(id: string): Promise<void> {
  const { error } = await supabase
    .from("documents_history")
    .delete()
    .eq("id", id);
  if (error) throw error;
}

export async function duplicateDocument(
  id: string,
  userId: string
): Promise<void> {
  const { data, error } = await supabase
    .from("documents_history")
    .select("*")
    .eq("id", id)
    .single();
  if (error || !data) throw error || new Error("Document not found");
  const newDoc = {
    ...data,
    id: undefined,
    date: new Date().toISOString(),
    status: "Borrador",
    user_id: userId,
  };
  await addDocument(newDoc);
}
